module.exports = __webpack_public_path__ + "img/LATIN10_13.0db1442b.jpg";